import { AuthGuard, provideConfig } from "@spartacus/core";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CmsPageGuard, PageSlotModule } from "@spartacus/storefront";
import { CheckoutStepsAccordionComponent } from "./kn-br-custom-checkout-accordion.component";
import { CheckoutStepsGuard } from "../checkout-guard";
import { EditCartConfirmationModalComponent } from "../edit-cart-confirmation-modal/edit-cart-confirmation-modal.component";

const routes: Routes = [
  {
    path: "checkout/pickup-person",
    component: CheckoutStepsAccordionComponent,
    canActivate: [CmsPageGuard, CheckoutStepsGuard],
    runGuardsAndResolvers: "always", 
  },
  {
    path: "checkout/pickup-store",
    component: CheckoutStepsAccordionComponent,
    canActivate: [CmsPageGuard, CheckoutStepsGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "checkout/payment",
    component: CheckoutStepsAccordionComponent,
    canActivate: [CmsPageGuard,CheckoutStepsGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "checkout/delivery-address",
    component: CheckoutStepsAccordionComponent,
    canActivate: [CmsPageGuard, CheckoutStepsGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "checkout/schedule-delivery",
    component: CheckoutStepsAccordionComponent,
    canActivate: [CmsPageGuard, CheckoutStepsGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "checkout/delivery-instructions",
    component: CheckoutStepsAccordionComponent,
    canActivate: [CmsPageGuard, CheckoutStepsGuard],
    runGuardsAndResolvers: "always",
  },
];

@NgModule({
    imports: [CommonModule, RouterModule.forChild(routes), PageSlotModule, CheckoutStepsAccordionComponent, EditCartConfirmationModalComponent],
})
export class CustomCheckoutAccordionModule {}
